import type {
  TpvModel,
  TpvExcelModel,
  TpvExcelTemplateResponse,
  TpvsRepository,
  TpvExcelUploadResponse,
} from '@/Store/domain'
import { HttpModel, PaginationModel } from '@/Shared/domain'
import { TpvForm } from '@/Store/ui/hooks'
import type { TpvFilters } from '@/Store/ui/hooks'

interface ITpvs {
  getTpvsData: (
    merchantTargetId: number,
    pageNum: number,
    filters: TpvFilters
  ) => Promise<HttpModel<PaginationModel<TpvModel>>>
  addNewTpv: (data: TpvForm) => Promise<HttpModel<boolean>>
  getTpvsDataExcel: (merchantTargetId: number, filters: TpvFilters) => Promise<HttpModel<TpvExcelModel>>
  getTerminalsMassiveExcelTemplate: (
    merchantTargetId: number,
    empty: boolean,
  ) => Promise<HttpModel<TpvExcelTemplateResponse>>
  validateOrder: (data: { excel: string }) => Promise<HttpModel<TpvExcelUploadResponse>>
  validateAndInsertTPVsExcel: (data: { excel: string }) => Promise<HttpModel<TpvExcelUploadResponse>>
}

export const TpvsContract = (tpvsRepository: TpvsRepository): ITpvs => ({
  getTpvsData: async (
    merchantTargetId: number,
    pageNum: number,
    filters: TpvFilters
  ): Promise<HttpModel<PaginationModel<TpvModel>>> =>
    await tpvsRepository.GetTpvsData(merchantTargetId, pageNum, filters),
  addNewTpv: async (data: TpvForm): Promise<HttpModel<boolean>> =>
    await tpvsRepository.AddNewTpv(data),
  getTpvsDataExcel: async (
    merchantTargetId: number,
    filters: TpvFilters
  ): Promise<HttpModel<TpvExcelModel>> =>
    await tpvsRepository.GetTpvsDataExcel(merchantTargetId, filters),
  getTerminalsMassiveExcelTemplate: async (
    merchantTargetId: number,
    empty: boolean,
  ): Promise<HttpModel<TpvExcelTemplateResponse>> =>
    await tpvsRepository.GetTerminalsMassiveExcelTemplate(merchantTargetId, empty),
  validateOrder: async (data: { excel: string }): Promise<HttpModel<TpvExcelUploadResponse>> =>
    await tpvsRepository.validateOrder(data),
  validateAndInsertTPVsExcel: async (data: { excel: string }): Promise<HttpModel<TpvExcelUploadResponse>> =>
    await tpvsRepository.validateAndInsertTPVsExcel(data),
})
